import { ShieldOff, Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import { cardService } from "../../services/card.service";

type Props = {
  cardId: string;
  userId: string;
  onChanged?: () => void;
};

export function ExperiencePrivacyActions({ cardId, userId, onChanged }: Props) {
  const revoke = async () => {
    await cardService.revokeLink(cardId, userId);
    toast.success("Private link revoked");
    onChanged?.();
  };

  const deleteExperience = async () => {
    await cardService.deleteExperience(cardId, userId);
    toast.success("Experience deleted");
    onChanged?.();
  };

  return (
    <div className="grid gap-3 md:grid-cols-2">
      <button
        type="button"
        onClick={revoke}
        className="flex items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3 text-[10px] font-black uppercase tracking-[0.2em] text-white/60 transition hover:bg-white/10 hover:text-white"
      >
        <ShieldOff size={15} />
        Revoke link
      </button>

      <button
        type="button"
        onClick={deleteExperience}
        className="flex items-center justify-center gap-2 rounded-2xl border border-rose-300/20 bg-rose-300/[0.07] px-4 py-3 text-[10px] font-black uppercase tracking-[0.2em] text-rose-100/80 transition hover:bg-rose-300/[0.12]"
      >
        <Trash2 size={15} />
        Delete experience
      </button>
    </div>
  );
}
